import { useCurrentCompanyContext } from "../components/AppShell/CurrentCompanyProvider"
import type { Data } from "../components/AppShell/CurrentCompanyProvider/gql"

type FeatureFlag<K extends "companyFeatureFlags" | "portalFeatureFlags"> =
  Data["currentCompany"][K][number]

export const useIsFeatureFlagEnabled = () => {
  const {
    currentCompany: { companyFeatureFlags, portalFeatureFlags },
  } = useCurrentCompanyContext()

  const isFlagsLoaded =
    Boolean(portalFeatureFlags) && Boolean(companyFeatureFlags)

  const getIsCompanyFlagEnabled = (
    flag: FeatureFlag<"companyFeatureFlags">
  ) => {
    return (companyFeatureFlags ?? []).includes(flag)
  }

  const getIsPortalFlagEnabled = (flag: FeatureFlag<"portalFeatureFlags">) => {
    return (portalFeatureFlags ?? []).includes(flag)
  }

  return { getIsCompanyFlagEnabled, getIsPortalFlagEnabled, isFlagsLoaded }
}
